
import { connect } from 'echarts/core'
import { mapGetters } from 'vuex'
import EnerEchartsPie from '@/components/enerEcharts/enerEchartsPie'
import enerOutlook from '@/api/eneroutlook'
import { getPivotArray } from '@/utils/enerFunctions'
import { getShortCodeForSerieCode, getColorForSerieCode } from '@/utils/eneroutlookFunctions'
import EnerLoader from '@/components/ui/enerLoader'

export default {
  name: 'ChartContainer',
  components: { EnerEchartsPie, EnerLoader },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      apiData: [],
      isChartReady: false,
      initOptions: {
        height: null
      },
      updateOptions: {
        notMerge: true
      }
    }
  },
  async fetch () {
    const serieFullCodes = this.config.items.map(item => item + '_' + this.config.displayUnit)
    const years = this.config.years
    const scenarioCodes = this.config.scenario
    // const zoneCodes = ['monde']
    let zoneCodes
    if (this.mapRegion !== this.world) {
      zoneCodes = [this.mapRegion.nrdCode]
    } else {
      zoneCodes = ['monde']
    }
    const requestParams = {
      fullCode: serieFullCodes,
      zoneCode: zoneCodes,
      scenarioCode: scenarioCodes,
      year: years,
      pagination: false
    }
    this.apiData = await enerOutlook.values(requestParams, this)
    connect('pie-chart-group')
  },
  computed: {
    ...mapGetters({
      scenariosContent: 'scenariosContent',
      mapRegion: 'page/mapRegion'
    })
  },
  methods: {
    chartDataset (scenario) {
      const categoryField = 'scenarioCode'
      const nameField = 'serieCode'
      const valueField = 'value'
      const filteredData = this.apiData.filter(item => item.scenarioCode === scenario.code)
      const chartDataset = getPivotArray(filteredData, categoryField, nameField, valueField)
      for (let i = 0; i < chartDataset.length; i++) {
        if (chartDataset[i][0] === categoryField) {
          chartDataset[i].push('color')
        } else {
          chartDataset[i].push(getColorForSerieCode(chartDataset[i][0]))
          chartDataset[i][0] = this.$t('shortTitle.' + getShortCodeForSerieCode(chartDataset[i][0]))
        }
      }
      return chartDataset
    },
    chartSeries (scenario) {
      const chartSeries = []
      const chartSerie = {
        label: {
          formatter (param) {
            return param.percent.toFixed(0) + '%'
          }
        },
        itemStyle: {
          color (param) {
            return param.data[2]
          }
        },
        type: 'pie',
        radius: ['50%', '60%'],
        top: 0,
        bottom: 40
      }
      chartSeries.push(chartSerie)
      return chartSeries
    },
    option (scenario) {
      const option = {
        legend: {
          top: 'bottom'
        },
        tooltip: {
          formatter (param) {
            return param.name + ' : ' + param.percent.toFixed(0) + '%'
          }
        },
        dataset: {
          source: this.chartDataset(scenario)
        },
        series: this.chartSeries(scenario)
      }
      if (scenario.code !== 'S1') {
        option.legend.show = false
      }
      return option
    }
  },
  watch: {
    mapRegion () {
      this.$fetch()
    }
  //   benchmarkRegions () {
  //     this.$fetch()
  //   }
  },
  fetchOnServer: false
}
